// components/ProRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProRoute = ({ userProfile, isLoading }) => {
    // 1. Si aún estamos cargando el perfil, mostramos un loader elegante
    if (isLoading) {
        return (
            <div className="min-h-screen bg-gray-900 flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
            </div>
        );
    }

    // 2. Si no hay usuario logueado, mandar a login
    if (!userProfile) {
        return <Navigate to="/login" replace />;
    }

    // 3. LA CLAVE: Verificar si es PRO
    // (Asumimos que si isPro es undefined es false)
    if (!userProfile.isPro) {
        // Si intenta entrar al dashboard sin pagar, lo mandamos a la configuración o a una landing de ventas
        return <Navigate to="/pro" replace />;
    }

    // 4. Si pasa todas las pruebas, renderizamos el contenido (Dashboard, etc.)
    return <Outlet />;
};

export default ProRoute;